import { render } from "./RequestPermissionEditorCmp.vue?vue&type=template&id=11d6a181"
import script from "./RequestPermissionEditorCmp.vue?vue&type=script&lang=js"
export * from "./RequestPermissionEditorCmp.vue?vue&type=script&lang=js"

import "./RequestPermissionEditorCmp.vue?vue&type=style&index=0&id=11d6a181&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__